import React, { useCallback, useEffect, useState } from "react";
import { scoreTableVisibleAtom } from "./models";
import { useAtom } from "@reatom/npm-react";

function ScoreTableBtn({ root, table, atom=null, stroke=undefined }) {
  // const [visibleScoreTable, setVisibleScoreTable] = useState(false)
  console.log('test', atom)

  const [visibleScoreTable, setVisibleScoreTable] = !atom 
    ? useAtom(scoreTableVisibleAtom) 
    : useAtom(atom)

  useEffect(() => {
    if (visibleScoreTable && table.current) {
      table.current.classList.remove('hide')
      setTimeout(()=>{
        table.current.scrollIntoView({
          behavior: 'smooth'
        })
      }, 500)
    } else if (table.current) {
      table.current.classList.add('hide')
    }
  }, [visibleScoreTable])

  const handleCLick = useCallback(() => {
    setVisibleScoreTable(!visibleScoreTable);
  }, [visibleScoreTable, table.current])

  return (
    <button 
      className={`button ${stroke===undefined ? '-fill' : ''}`} 
      onClick={handleCLick}
    >
      {visibleScoreTable ? root.dataset.textHide : root.dataset.textShow}
    </button>
  )
}

export default ScoreTableBtn